import { c as _c } from "react/compiler-runtime";
import { Check } from '@phosphor-icons/react';
import { sanitizeBackendHtml } from '@/lib/security/sanitize-html';
export function AppExperienceChecklist(t0) {
  const $ = _c(4);
  const {
    list
  } = t0;
  if (list?.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== list) {
    t1 = list?.map(_temp);
    $[0] = list;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <ul className="flex flex-col gap-y-4">{t1}</ul>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(title, index) {
  return <li key={index} className="relative"><Check className="absolute size-6 rounded-full bg-lightgreen p-1" weight="bold" /><div className="ml-10 font-body-copy" dangerouslySetInnerHTML={{
      __html: sanitizeBackendHtml(title)
    }} /></li>;
}